import './product-stage.scss';
import { gsap } from 'gsap';

class ProductStage {
    constructor (element, options) {
        const settings = {
            initAttr: 'data-product-stage',
            copy: 'copy',
            cta: 'cta'
        };

        this.settings = Object.assign({}, settings, options);
        this.$productStage = element;
        this.$animate = true;
        this.$currentProgressAdjustment = 0;
        this.$copyTiming = null;
        this.$firstLoad = true;
        this.$copyCTADelay = null;
    }

    init () {
        if (!window.location.hash) {
            setTimeout(() => {
                window.scrollTo(0, 0);
                this.$productStage.classList.add('is--animated');
                this.scrollAnimation();
            }, 100);
        }
    }

    scrollAnimation () {
        const observerElements = document.querySelectorAll('[data-product-stage="trigger"]');

        observerElements.forEach(el => {
            const image = el.querySelector('[data-product-stage="image"]');
            const headline = el.querySelector('[data-product-stage="headline"]');
            const copy = el.querySelector('[data-product-stage="copy"]');
            const cta = el.querySelector('[data-product-stage="cta"]');

            el.observer = new IntersectionObserver(entry => {
                if (entry[0].intersectionRatio > 0) {
                    gsap.ticker.add(el.progressTween);
                } else {
                    gsap.ticker.remove(el.progressTween);
                }
            });

            el.tl = gsap.timeline({ paused: true });
            if (window.innerWidth < 768) {
                /* MOBILE */
                el.tl
                    .to(image, {
                        scale: 1,
                        ease: 'easeOut'
                    }, '<')
                    .to(headline, {
                        scale: 1,
                        marginTop: '0vh',
                        duration: 0.4,
                        ease: 'easeIn'
                    }, '<')
                    .to(copy, {
                        opacity: 1,
                        duration: 0.4,
                        ease: 'easeIn'
                    }, '<')
                    .to(copy, {
                        marginTop: '0vh',
                        duration: 1,
                        ease: 'easeIn'
                    }, '<')
                    .to(cta, {
                        opacity: 1,
                        ease: 'easeIn'
                    }, '<')
                    .to(cta, {
                        ease: 'easeIn',
                        onComplete: () => {
                            // this.$animate = false;
                            // this.$copy.classList.add('is--visible');
                            // this.$cta.classList.add('is--visible');
                        }
                    }, '<');
            } else {
                /* DESKTOP */
                this.$copyTiming = '<';
                this.$copyCTADelay = 0.1;
                el.tl
                    .to(image, {
                        scale: 1,
                        translateY: '0vw',
                        ease: 'easeOut'
                    }, '<')
                    .to(headline, {
                        scale: 1,
                        translateY: '3vw',
                        ease: 'easeIn'

                    }, '<')
                    .to(copy, {
                        translateY: '4vw',
                        ease: 'easeIn',
                        delay: this.$copyCTADelay
                    }, this.$copyTiming)
                    .to(copy, {
                        opacity: 1,
                        ease: 'easeIn'
                    }, this.$copyTiming)
                    .to(cta, {
                        opacity: 1,
                        ease: 'easeIn',
                        delay: this.$copyCTADelay
                    }, '<')
                    .to(cta, {
                        duration: 0.4,
                        translateY: '4.4vw',
                        ease: 'easeIn',
                        onComplete: () => {
                            this.$animate = false;
                            // this.$copy.classList.add('is--visible');
                            // this.$cta.classList.add('is--visible');
                        }
                    }, '<');
            }

            el.progressTween = () => {
                // Get scroll distance to bottom of viewport.
                const scrollPosition = (window.scrollY + window.innerHeight);

                // Get element's position relative to bottom of viewport.
                const elPosition = (scrollPosition - el.offsetTop);

                // Set desired duration.
                const durationDistance = this.$productStage.offsetHeight;

                // Calculate tween progresss.
                const currentProgress = (elPosition / durationDistance);

                if (this.$firstLoad) {
                    if (window.innerWidth < 768) {
                        this.$currentProgressAdjustment = 0.320695102685624;
                    } else {
                        this.$currentProgressAdjustment = currentProgress;
                    }
                    this.$firstLoad = false;
                }

                // Set progress of gsap timeline.
                if (this.$animate) {
                    el.tl.progress(currentProgress - this.$currentProgressAdjustment);
                }
            };

            if (this.$animate) {
                el.observer.observe(el);
            }
        });
    }
}

export { ProductStage };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$productStage = $context.querySelectorAll('[data-product-stage="root"]');

        for (let i = 0; i < $$productStage.length; i++) {
            const $productStage = new ProductStage($$productStage[i]);
            $productStage.init();
        }
    }
});
